import { render, staticRenderFns } from "./enroll.vue?vue&type=template&id=2d88007c&scoped=true&"
import script from "./enroll.vue?vue&type=script&lang=js&"
export * from "./enroll.vue?vue&type=script&lang=js&"
import style0 from "./enroll.vue?vue&type=style&index=0&id=2d88007c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d88007c",
  null
  
)

export default component.exports